import axios from '@/services'

export default {
  violatedFiles: async (params) => await axios.get('/api/bulkRequest/violatedFiles', { params }),
  prepareResiForEstab: async (data, params) =>
    await axios.post('/api/udb/personImmigrationFile/prepareResiForEstab/', data, { params })
}
